var TrilliumPersonalisationSimulator = (function ($) {

    var containerSelector = "#trilliumPersonalisationSimulator:not(.bound)";

    var checkIfContainerExists = function () {
        if ($(containerSelector) !== null &&
            $(containerSelector).length) {
            $(containerSelector).addClass('bound');
            return true;
        }
        return false;
    };

    var bindPersonalisationSimulatorActions = function () {

        var $container = $("#trilliumPersonalisationSimulator:not(.bound)");
        var $containerCta = $("#trilliumPersonalisationSimulator_cta");
        var $containerHideCta = $("#trilliumPersonalisationSimulator_hideCta");
        var $containerRemoveGroupsCta = $("#trilliumPersonalisationSimulator_removeGroupsCta");
        var $containerOptions = $("#trilliumPersonalisationSimulator_options");
        var $containerOptionsSelect = $("#trilliumPersonalisationSimulator_optionsSelect");
        var $containerOptionsSelectedGroups = $("#trilliumPersonalisationSimulator_selectedGroups");
        var $containerOptionsRemoveSingleGroup = $(".trilliumPersonalisationSimulator_removeGroup");
        var $containerCookieName = $("#trilliumPersonalisationSimulator_cookieName");
        var $containerCookieSeparator = $("#trilliumPersonalisationSimulator_cookieNameSeparator").val();

        var cookieName = $containerCookieName.val();

        if (cookieName !== undefined &&
            cookieName !== null &&
            cookieName !== '') {

            $containerCta.on('click', function () {
                $containerOptions.show();
                $containerCta.hide();
                $container.addClass('displayPanel');
            });

            $containerHideCta.on('click', function () {
                $containerOptions.hide();
                $containerCta.show();
                $container.removeClass('displayPanel');
            });

            $containerRemoveGroupsCta.on('click', function () {
                createCookie(cookieName, '', 1);
                location.reload();
            });

            $containerOptionsSelect.on('change', function () {
                var selectedGroups = $containerOptionsSelectedGroups.val();
                var selectedGroupsArray = selectedGroups.split($containerCookieSeparator);
                selectedGroupsArray.push(this.value);

                createCookie(cookieName, selectedGroupsArray.join($containerCookieSeparator), 1);
                location.reload();
            });

            $containerOptionsRemoveSingleGroup.on('click', function () {
                var selectedGroups = $containerOptionsSelectedGroups.val();
                var selectedGroupsArray = selectedGroups.split($containerCookieSeparator);
                var groupToRemove = '' + $(this).data('group-id');

                if (groupToRemove !== undefined && groupToRemove !== null) {
                    var indexOfGroup = selectedGroupsArray.indexOf(groupToRemove);
                    if (indexOfGroup !== undefined && indexOfGroup > 0) {
                        selectedGroupsArray.splice(indexOfGroup, 1);
                        createCookie(cookieName, selectedGroupsArray.join($containerCookieSeparator), 1);
                        location.reload();
                    }
                }

            });

            var createCookie = function (name, value, days) {
                var expires;

                if (days) {
                    var date = new Date();
                    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                    expires = "; expires=" + date.toGMTString();
                } else {
                    expires = "";
                }
                document.cookie = name + "=" + value + expires + "; path=/";
            }
        }
    };

    return {
        init: function () {
            if (checkIfContainerExists()) {
                bindPersonalisationSimulatorActions();
            }
        }
    };

})(window.jQuery);

window.TrilliumPersonalisationSimulator = TrilliumPersonalisationSimulator;
